import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, reactive } from 'vue';
import { type FullColorObject, useColor } from '@/composables/color';
import SaturationBoard from './SaturationBoard.vue';
import HueSlider from './HueSlider.vue';
import AlphaSlider from './AlphaSlider.vue';
import CInput from '../CInput';
import CButton from '@/components/shared/CButton';

type ColorPickerMode = 'cmyk' | 'rgb';


export default /*#__PURE__*/_defineComponent({
  __name: 'CSolidColor',
  props: {
    value: null,
    mode: { default: 'rgb' },
    initialColor: { default: '#8C2525' },
    allowReset: { type: Boolean },
    resetText: { default: 'Reset' }
  },
  emits: ["input", "reset", "eye-dropper-used", "using-eye-dropper"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: FullColorObject): void;
    (event: 'reset', value?: FullColorObject): void;
    (event: 'eye-dropper-used'): void;
    (event: 'using-eye-dropper'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: FullColorObject, mode: ColorPickerMode, initialColor: string, allowReset?: boolean, resetText: string };





const colord = useColor();
const inputModel = reactive({
    hex: '',
    rgb: { r: 0, g: 0, b: 0 },
    cmyk: { c: 0, m: 0, y: 0, k: 0 },
    alpha: 1
});

const color = computed({
    get: () => {
        const value = props.value;
        if (!value?.hsl || !value?.hsv) return;
        return value;
    },
    set: (value: FullColorObject | undefined) => {
        emit('input', value!);
    }
});

const inputModeSet = computed((): Record<string, number> => inputModel[props.mode]);

const rbgPreview = computed(() => (color.value ? colord.hexToHexa(color.value.hex, color.value.a) : ''));

onBeforeMount(() => {
    if (!props.value) {
        onColorChange({ hex: props.initialColor, a: 1 });
        return;
    } else if (!props.value.rgb || !props.value.cmyk || !props.value.rounded) {
        onColorChange(props.value)
        return;
    }
    updateColorModel(props.value);
});

const onColorChange = (partialColor: Partial<FullColorObject>) => {
    if (partialColor.hex?.length && !partialColor.hex.includes('#')) {
        partialColor.hex = `#${partialColor.hex}`;
    }
    partialColor.a = partialColor.a ?? color.value?.a;
    const newColor = colord.getColorObj(partialColor);
    if (!newColor) return;

    updateColorModel(newColor);
};

const updateColorModel = (value: FullColorObject) => {
    color.value = value;
    inputModel.hex = value.hex.substring(1);
    inputModel.alpha = value.a;
    inputModel.rgb = { ...value.rounded.rgb };
    inputModel.cmyk = { ...value.rounded.cmyk };
};

const onReset = () => {
    emit('reset', color.value);
};

const openEyedropper = async () => {
    if (!window.EyeDropper) return;
    const eyedropper = new window.EyeDropper();
    emit('using-eye-dropper');
    const colorClicked = await eyedropper.open();
    const partialColor = { hex: colorClicked.sRGBHex, a: 1 };
    updateColorModel(colord.getColorObj(partialColor)!);
    emit('eye-dropper-used');
};

return { __sfc: true,props, emit, colord, inputModel, color, inputModeSet, rbgPreview, onColorChange, updateColorModel, onReset, openEyedropper, SaturationBoard, HueSlider, AlphaSlider, CInput, CButton }
}

})